export const getters = {
  checkQuickLaunch: (state) => {
    return (keyword) => {
      if (state.quickLaunch.apps.includes(keyword)) {
        return true
      } else {
        return false
      }
    }
  }
}
